import { render, staticRenderFns } from "./ScheduledAccess.vue?vue&type=template&id=54334052"
import script from "./ScheduledAccess.vue?vue&type=script&lang=js"
export * from "./ScheduledAccess.vue?vue&type=script&lang=js"
import style0 from "./ScheduledAccess.vue?vue&type=style&index=0&id=54334052&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports